module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block accordion-list"
  }, [_c('f7-list', [_vm._l((_vm.items), function(item) {
    return _vm._t("default", [(item.link) ? _c('f7-list-item', {
      class: item.disable === true ? 'disabled' : '',
      attrs: {
        "link": item.link,
        "title": item.label,
        "link-view": "#main-view",
        "link-close-panel": ""
      },
      on: {
        "click": function($event) {
          _vm.onClick(item)
        }
      }
    }) : _c('li', {
      staticClass: "accordion-item"
    }, [_c('f7-link', {
      staticClass: "item-link item-content",
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "accordion-item-content"
    }, [_c('f7-block', [_c('f7-list', [_vm._l((item.items), function(subitem) {
      return _vm._t("default", [_c('f7-list-item', {
        class: subitem.disable === true ? 'disabled' : '',
        attrs: {
          "link": subitem.link,
          "title": subitem.label,
          "link-view": "#main-view",
          "link-close-panel": ""
        }
      })])
    })], 2)], 1)], 1)], 1)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c7da14c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VSidebar.vue
// module id = 133
// module chunks = 1